
angular.module('bmsApp.crm.customer').factory('CustomerTypeSvc', function (CRUDSvc, CUSTOMER_TYPE_API) {

	return {
		options: function () {
			return CRUDSvc.get(CUSTOMER_TYPE_API.OPTIONS);
		}
	};

}).constant('CUSTOMER_TYPE_API', {
	OPTIONS: 'api/customerType/options'
});
